export const OPERATOR_MODEL_TIERS = ["haiku", "sonnet", "opus", "gpt"] as const;

export type OperatorModelTier = (typeof OPERATOR_MODEL_TIERS)[number];

export const WEB_BROWSER_MODEL_TIERS = ["haiku", "sonnet", "opus"] as const;
export type WebBrowserModelTier = (typeof WEB_BROWSER_MODEL_TIERS)[number];

export type RemoteDesktopExecuteModelTier = OperatorModelTier;
export const REMOTE_DESKTOP_EXECUTE_MODEL_TIERS = OPERATOR_MODEL_TIERS;
